export default {
  setAccountConfig(state, data) {
    state.accountConfig = data;
  },

  setAccountInfo(state, data) {
    state.accountInfo = data;
  },
  setAccountInfoCode(state, data) {
    state.accountInfoCode = data;
  },

  setLastAccount(state, data) {
    state.lastAccount = data;
  },

  setVoucherNoteType(state, data) {
    state.voucherNoteType = data;
  },

  setDefaultVoucherDescription(state, data) {
    state.defaultVoucherDescription = data;
  },

  setFinancialRatio(state, data) {
    state.financialRatio = data;
  },

  setFinancialRatioItem(state, data) {
    state.financialRatioItem = data;
  },

  setNumerator(state, numeratorItems) {
    state.numerator = numeratorItems;
  },

  setDenominator(state, denominatorItems) {
    state.denominator = denominatorItems;
  },

  setVouchers(state, data) {
    state.vouchers = data;
  },
  setVouchersTotalCount(state, data) {
    state.vouchersTotalCount = data;
  },
  setVoucher(state, data) {
    state.voucher = data;
  },

  setVoucherNavigation(state, data) {
    state.voucherNavigation = data;
  },

  setVoucherCheckCreate(state, data) {
    state.voucherCheckCreate = data;
  },
  setVoucherCheckUpdate(state, data) {
    state.voucherCheckUpdate = data;
  },

  setVoucherId(state, data) {
    state.voucherId = data;
  },

  setLastVoucherInfo(state, data) {
    state.lastVoucherInfo = data;
  },

  setVoucherInfoDate(state, data) {
    state.voucherInfoDate = data;
  },

  setCurrentVoucherId(state, data) {
    state.currentVoucherId = data;
  },

  setVoucherAttaches(state, data) {
    state.voucherAttaches = data;
  },

  setPersonCredits(state, data) {
    state.personCredits = data;
  },

  setUserLimitAccounts(state, data) {
    state.userLimitAccounts = data;
  },

  setVoucherNotes(state, data) {
    state.voucherNotes = data;
  },

  setConfirmCartable(state, data) {
    state.confirmCartable = data;
  },
  setUnConfirmCartable(state, data) {
    state.unConfirmCartable = data;
  },

  setVoucherReview(state, data) {
    state.voucherReview = data;
  },

  setEmptyVoucher(state, data) {
    state.emptyVoucher = data;
  },

  setArchiveVoucher(state, data) {
    state.archiveVoucher = data;
  },
  setDebtorOrCreditorDeclarations(state, data) {
    state.debtorOrCreditorDeclarations = data;
  },
  setDebtorOrCreditorDeclaration(state, data) {
    state.debtorOrCreditorDeclaration = data;
  },
  setDebtorOrCreditorDeclarationId(state, data) {
    state.debtorOrCreditorDeclarationId = data;
  },

  setDebtorOrCreditorDeclarationCode(state, data) {
    state.debtorOrCreditorDeclarationCode = data;
  },

  setDebtorOrCreditorDeclarationNavigation(state, data) {
    state.debtorOrCreditorDeclarationNavigation = data;
  },

  setDebtorOrCreditorDeclarationCheckDelete(state, data) {
    state.debtorOrCreditorDeclarationCheckDelete = data;
  },
  setDebtorOrCreditorDeclarationVoucher(state, data) {
    state.debtorOrCreditorDeclarationVoucher = data;
  },

  setVoucherMaxCode(state, data) {
    state.voucherMaxCode = data;
  },

  setVoucherMaxNumber(state, data) {
    state.voucherMaxNumber = data;
  },

  setVoucherMaxTempNumber(state, data) {
    state.voucherMaxTempNumber = data;
  },

  setVoucherVerification(state, data) {
    state.voucherVerification = data;
  },

  setGeneralJournalReport(state, data) {
    state.generalJournalReport = data;
  },

  setGeneralJournalSummaryReport(state, data) {
    state.generalJournalSummaryReport = data;
  },

  setAccountOperationDetailReport(state, data) {
    state.accountOperationDetailReport = data;
  },

  setBasedOnSaleManagerListReport(state, data) {
    state.basedOnSaleManagerListReport = data;
  },

  setReportOfCreditorsAndDebtorsBasedOnSalesManagers(state, data) {
    state.reportOfCreditorsAndDebtorsBasedOnSalesManagers = data;
  },

  setOperationalLedgerAccountTurnoverReport(state, data) {
    state.operationalLedgerAccountTurnoverReport = data;
  },

  setPersonOperationDetailReport(state, data) {
    state.personOperationDetailReport = data;
  },
  setPersonOperationDetailSalt(state, data) {
    state.personOperationDetailSalt = data;
  },
  setTrialBalance4ColumnsReport(state, data) {
    state.trialBalance4ColumnsReport = data;
  },
  setTrialBalance6ColumnsReport(state, data) {
    state.trialBalance6ColumnsReport = data;
  },
  setDetailTrialBalance4ColumnsReport(state, data) {
    state.detailTrialBalance4ColumnsReport = data;
  },
  setTrialBalance8ColumnsReport(state, data) {
    state.trialBalance8ColumnsReport = data;
  },
  setDetailTrialBalance6ColumnsReport(state, data) {
    state.detailTrialBalance6ColumnsReport = data;
  },
  setDetailTrialBalance8ColumnsReport(state, data) {
    state.detailTrialBalance8ColumnsReport = data;
  },
  setAccountWithPersonReport(state, data) {
    state.accountWithPersonReport = data;
  },
  setFloatAccount1OperationDetail(state, data) {
    state.floatAccount1OperationDetail = data;
  },
  setFloatAccount2OperationDetail(state, data) {
    state.floatAccount2OperationDetail = data;
  },
  setFloatAccount3OperationDetail(state, data) {
    state.floatAccount3OperationDetail = data;
  },
  setFloatAccount4OperationDetail(state, data) {
    state.floatAccount4OperationDetail = data;
  },
  setFloatAccount5OperationDetail(state, data) {
    state.floatAccount5OperationDetail = data;
  },
  setFloatAccountTextOperationDetail(state, data) {
    state.floatAccountTextOperationDetail = data;
  },

  setAccountWithFloatAccount1(state, data) {
    state.accountWithFloatAccount1 = data;
  },
  setAccountWithFloatAccount2(state, data) {
    state.accountWithFloatAccount2 = data;
  },
  setAccountWithFloatAccount3(state, data) {
    state.accountWithFloatAccount3 = data;
  },
  setAccountWithFloatAccount4(state, data) {
    state.accountWithFloatAccount4 = data;
  },
  setAccountWithFloatAccount5(state, data) {
    state.accountWithFloatAccount5 = data;
  },
  setAccountWithFloatAccountText(state, data) {
    state.accountWithFloatAccountText = data;
  },
  setAccountWithFloatAccountGroupReport(state, data) {
    state.accountWithFloatAccountGroupReport = data;
  },

  setFloatAccount1WithPerson(state, data) {
    state.floatAccount1WithPerson = data;
  },
  setFloatAccount2WithPerson(state, data) {
    state.floatAccount2WithPerson = data;
  },
  setFloatAccount3WithPerson(state, data) {
    state.floatAccount3WithPerson = data;
  },
  setFloatAccount4WithPerson(state, data) {
    state.floatAccount4WithPerson = data;
  },
  setFloatAccount5WithPerson(state, data) {
    state.floatAccount5WithPerson = data;
  },
  setFloatAccountTextWithPerson(state, data) {
    state.floatAccountTextWithPerson = data;
  },
  setFloatAccount1WithAccount(state, data) {
    state.floatAccount1WithAccount = data;
  },
  setFloatAccount2WithAccount(state, data) {
    state.floatAccount2WithAccount = data;
  },
  setFloatAccount3WithAccount(state, data) {
    state.floatAccount3WithAccount = data;
  },
  setFloatAccount4WithAccount(state, data) {
    state.floatAccount4WithAccount = data;
  },
  setFloatAccount5WithAccount(state, data) {
    state.floatAccount5WithAccount = data;
  },
  setFloatAccountTextWithAccount(state, data) {
    state.floatAccountTextWithAccount = data;
  },
  setStatusDocumentReport(state, data) {
    state.statusDocumentReport = data;
  },
  setTrialBalanceReport(state, data) {
    state.trialBalanceReport = data;
  },

  setPersonWithFloatAccount1(state, data) {
    state.personWithFloatAccount1 = data;
  },
  setPersonWithFloatAccount2(state, data) {
    state.personWithFloatAccount2 = data;
  },
  setPersonWithFloatAccount3(state, data) {
    state.personWithFloatAccount3 = data;
  },
  setPersonWithFloatAccount4(state, data) {
    state.personWithFloatAccount4 = data;
  },
  setPersonWithFloatAccount5(state, data) {
    state.personWithFloatAccount5 = data;
  },
  setPersonWithFloatAccountText(state, data) {
    state.personWithFloatAccountText = data;
  },
  setPersonWithAccount(state, data) {
    state.personWithAccount = data;
  },
  setPersonCreditsReport(state, data) {
    state.personCreditsReport = data;
  },
  setPersonalAccountBalanceReport(state, data) {
    state.personalAccountBalanceReport = data;
  },
  setBalanceReportPersonsList(state, data) {
    state.balanceReportPersonsList = data;
  },

  setElectronicLedgerReport(state, data) {
    state.electronicLedgerReport = data;
  },
  setElectronicLedgerExportData(state, data) {
    state.electronicLedgerExportData = data;
  },
  setPersonFinalVoucherReport(state, data) {
    state.personFinalVoucherReport = data;
  },
  setPersonOfficeReport(state, data) {
    state.personOfficeReport = data;
  },
  setPersonMultiLevelLedgerReport(state, data) {
    state.personMultiLevelLedgerReport = data;
  },

  setAccountTreeReport(state, data) {
    state.accountTreeReport = data;
  },
  setFloatAccount1BalanceReport(state, data) {
    state.floatAccount1BalanceReport = data;
  },
  setFloatAccount2BalanceReport(state, data) {
    state.floatAccount2BalanceReport = data;
  },
  setFloatAccount3BalanceReport(state, data) {
    state.floatAccount3BalanceReport = data;
  },
  setFloatAccount4BalanceReport(state, data) {
    state.floatAccount4BalanceReport = data;
  },
  setFloatAccount5BalanceReport(state, data) {
    state.floatAccount5BalanceReport = data;
  },
  setFloatAccountTextBalanceReport(state, data) {
    state.floatAccountTextBalanceReport = data;
  },

  setReviewAccounts(state, data) {
    state.reviewAccounts = data;
  },
  setMonthlyAccountingVoucherReport(state, data) {
    state.monthlyAccountingVoucherReport = data;
  },
  setMonthlyAccountingVoucherExportData(state, data) {
    state.monthlyAccountingVoucherExportData = data;
  },

  setFloatAccount1Office(state, data) {
    state.floatAccount1Office = data;
  },
  setFloatAccount2Office(state, data) {
    state.floatAccount2Office = data;
  },
  setFloatAccount3Office(state, data) {
    state.floatAccount3Office = data;
  },
  setFloatAccount4Office(state, data) {
    state.floatAccount4Office = data;
  },
  setFloatAccount5Office(state, data) {
    state.floatAccount5Office = data;
  },
  setFloatAccountTextOffice(state, data) {
    state.floatAccountTextOffice = data;
  },
  setRouteData(state, data) {
    state.routeData = data;
  },

  setFinalizationDocument(state, data) {
    state.finalizationDocument = data;
  },

  setUnFinalizationDocument(state, data) {
    state.unFinalizationDocument = data;
  },

  setProfitAndLossIncomesReport(state, data) {
    state.profitAndLossIncomesReport = data;
  },
  setProfitAndLossCostsReport(state, data) {
    state.profitAndLossCostsReport = data;
  },
  setBalanceSheetReport(state, data) {
    state.balanceSheetReport = data;
  },

  setFinancialRatioReport(state, data) {
    state.financialRatioReport = data;
  },

  setVoucherDetail(state, data) {
    state.voucherDetail = data;
  },

  setAccountOfficeReport(state, data) {
    state.accountOfficeReport = data;
  },

  setPrintVoucherInfo(state, data) {
    state.printVoucherInfo = data;
  },
  setPrintLink(state, data) {
    state.printLink = data;
  },

  setPrintAccountOperationDetailReportInfo(state, data) {
    state.printAccountOperationDetailReportInfo = data;
  },

  setDashboardAccountOffice(state, data) {
    state.dashboardAccountOffice = data;
  },
  setDashboardAccountOfficeChart(state, data) {
    state.dashboardAccountOfficeChart = data;
  },

  setFloatAccount1BalanceTreeReport(state, data) {
    state.floatAccount1BalanceTreeReport = data;
  },

  setFloatAccount2BalanceTreeReport(state, data) {
    state.floatAccount2BalanceTreeReport = data;
  },

  setFloatAccount3BalanceTreeReport(state, data) {
    state.floatAccount3BalanceTreeReport = data;
  },

  setFloatAccount4BalanceTreeReport(state, data) {
    state.floatAccount4BalanceTreeReport = data;
  },

  setFloatAccount5BalanceTreeReport(state, data) {
    state.floatAccount5BalanceTreeReport = data;
  },
  setFloatAccountTextBalanceTreeReport(state, data) {
    state.floatAccountTextBalanceTreeReport = data;
  },

  setRequiredDate(state, data) {
    state.requiredDate = data;
  },

  setCloseAccountStep(state, data) {
    state.closeAccountStep = data;
  },

  setPreviewCloseTemporaryAccount(state, data) {
    state.previewCloseTemporaryAccount = data;
  },

  setPreviewClosePermanentAccount(state, data) {
    state.previewClosePermanentAccount = data;
  },

  setPreviewFinalDate(state, data) {
    state.previewFinalDate = data;
  },

  setIsDeleteVoucher(state, data) {
    state.isDeleteVoucher = data;
  },

  setAttachDetailVoucher(state, data) {
    state.attachDetailVoucher = data;
  },

  setVoucherNotesReport(state, data) {
    state.voucherNotesReport = data;
  },

  setAccountCurrencyMonitoringProcess(state, data) {
    state.accountCurrencyMonitoringProcess = data;
  },

  setAccountCurrencyMonitoringReport(state, data) {
    state.accountCurrencyMonitoringReport = data;
  },

  setAccountCurrencyMonitoringReportDetail(state, data) {
    state.accountCurrencyMonitoringReportDetail = data;
  },

  setAccountCurrencyTrialBalanceReport(state, data) {
    state.accountCurrencyTrialBalanceReport = data;
  },

  setAccountCurrencyMonitoringNotProcessed(state, data) {
    state.accountCurrencyMonitoringNotProcessed = data;
  },

  setIsError(state, data) {
    state.isError = data;
  },

  setCartableLog(state, data) {
    state.cartableLog = data;
  },

  setVoucherManagementCartable(state, data) {
    state.voucherManagementCartable = data;
  },

  setVoucherMerge(state, data) {
    state.voucherMerge = data;
  },
  setVoucherMergeDetails(state, data) {
    state.voucherMergeDetails = data;
  },
  setVoucherMergeResult(state, data) {
    state.voucherMergeResult = data;
  },
};
